import { ModalProps } from '@chakra-ui/react';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import React from 'react';
import CustomButton from '../form/CustomButton';

type Props = {
  children: React.ReactNode,
  title: string,
  actionBtnClick: () => void,
  [x: string]: any,
  actionBtnText?: string,
  cancelBtnText?: string,
  cancelBtnClick?: () => void,
  isLoading?: boolean,
  isSubmitting?: boolean,
  hasCancelBtn?: boolean,
  actionBtn?: JSX.Element,
} & ModalProps;

const CustomAppModal = React.forwardRef(
  (
    {
      title,
      actionBtnText,
      cancelBtnText,
      actionBtnClick,
      cancelBtnClick,
      children,
      isLoading,
      isSubmitting,
      hasCancelBtn = false,
      actionBtn,
      ...rest
    }: Props,
    ref
  ) => {
    const { isOpen, onOpen, onClose } = CC.useDisclosure();

    React.useImperativeHandle(ref, () => ({
      onOpen,
      onClose,
    }));

    return (
      <>
        <CC.Modal
          scrollBehavior="inside"
          {...rest}
          isOpen={isOpen}
          onClose={cancelBtnClick || onClose}
        >
          <CC.ModalOverlay />
          <CC.ModalContent>
            <CC.ModalHeader>{title}</CC.ModalHeader>
            {!isSubmitting && <CC.ModalCloseButton />}
            <CC.ModalBody>{children}</CC.ModalBody>

            <CC.ModalFooter>
              {actionBtn || (
                <CustomButton
                  loading={isLoading}
                  onClick={actionBtnClick}
                  mr="2"
                >
                  {actionBtnText || 'Ok'}
                </CustomButton>
              )}
              {hasCancelBtn && <CustomButton
                onClick={cancelBtnClick || onClose}
                variant="ghost"
                mr={3}
              >
                {cancelBtnText || 'Annuler'}
              </CustomButton>}
            </CC.ModalFooter>
          </CC.ModalContent>
        </CC.Modal>
      </>
    );
  }
);

export default CustomAppModal;
